// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "BadgeTooltipV1" + "." + "9299739b6a43ca00" + ".js"
}